import request from '@/utils/request'

export function isSimpleUI(params) {
  return request({
    url: '/api/workstation/isSimpleUI',
    method: 'get',
    params,
  })
}
export function getRegionByGroup(params) {
  return request({
    url: '/api/region/getByNetGroupId',
    method: 'get',
    params,
  })
}
export function getWi(params) {
  return request({
    url: '/api/workstation/getWi',
    method: 'get',
    nonstandard: true,
    params,
  })
}
export function gJobInfo(params) {
  return request({
    url: '/api/workstation/jobInfo',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function getBarInfo(params) {
  return request({
    url: '/api/workstation/barInfo',
    method: 'get',
    nonstandard: true,
    params,
  })
}
export function startReq(params) {
  return request({
    url: '/api/workstation/start',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function endReq(params) {
  return request({
    url: '/api/workstation/end',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function jobDetailInfo(params) {
  return request({
    url: '/api/workstation/jobDetailInfo',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function getQueue(params) {
  return request({
    url: '/api/workstation/getQueue',
    nonstandard: true,
    method: 'get',
    params,
  })
}
export function reverseStart(regionCode, jobId) {
  return request({
    url: '/api/workstation/reverseStart',
    nonstandard: true,
    method: 'get',
    params: {
      regionCode,
      jobId,
    },
  })
}
export function agvNet(regionCode, jobId, flag) {
  return request({
    url: flag ? '/api/agv/job/start' : '/api/agv/job/end',
    method: 'get',
    params: {
      regionCode,
      jobId,
    },
  })
}
export function preEndCheckForDisplay(params) {
  return request({
    url: '/api/workstation/preEndCheckForDisplay',
    method: 'get',
    params,
  })
}
export function getIsManualBinding(params) {
  return request({
    url: '/api/workstation/getIsManualBinding',
    method: 'get',
    nonstandard: true,
    params,
  })
}
export function checkManualTag(tagId) {
  return request({
    url: '/api/workstation/checkManualTag',
    method: 'get',
    nonstandard: true,
    params: {
      tagId,
    },
  })
}
export function preEndCheck(params) {
  return request({
    url: '/api/workstation/preEndCheck',
    method: 'get',
    nonstandard: true,
    params,
  })
}
export function getMatAllExist(params) {
  return request({
    url: '/api/workstation/getMatAllExist',
    method: 'get',
    nonstandard: true,
    params,
  })
}
